module.exports = __webpack_public_path__ + "static/media/05家.6456a4d1.png";